import Settings from "@/domain/entities/user/Settings";
import {
    Language,
    Settings as SettingsMailvista,
} from "@cs_teamwaydev/mailvista-sdk_react";
import {
    displayPreferencesToDomainMapper,
    displayPreferencesToSDKMapper,
} from "./displayPreferencesMapper";
import {
    notificationPreferencesToDomainMapper,
    notificationPreferencesToSDKMapper,
} from "./notificationPreferencesMapper";
import { themeToDomainMapper, themeToSDKMapper } from "./themeMapper";

const settingsToDomainMapper = (settings: SettingsMailvista): Settings =>
    new Settings({
        theme: themeToDomainMapper(settings.theme),
        displayPreferences: displayPreferencesToDomainMapper(
            settings.displayPreferences,
        ),
        preferredLanguage: settings.preferredLanguage as Language,
        customSignature: settings.customSignature,
        notificationPreferences: notificationPreferencesToDomainMapper(
            settings.notificationPreferences,
        ),
    });

const settingsToSDKMapper = (settings: Settings): SettingsMailvista => ({
    theme: themeToSDKMapper(settings.theme),
    displayPreferences: displayPreferencesToSDKMapper(
        settings.displayPreferences,
    ),
    preferredLanguage: settings.preferredLanguage as Language,
    customSignature: settings.customSignature,
    notificationPreferences: notificationPreferencesToSDKMapper(
        settings.notificationPreferences,
    ),
});

export { settingsToDomainMapper, settingsToSDKMapper };
